





import Vue from 'vue'
import Mappa from '@/components/puntiluce/Mappa.vue'
import Azioni from '@/components/puntiluce/Azioni.vue'

export default Vue.extend({
    components: {
        Mappa,
        Azioni
    }
})
